import { isDarkTheme } from '../../../../eliot-components/src/theme';
import { makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';
import { darken } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  updatingState: {
    backgroundColor: theme.palette.secondary.light,
    display: 'inline-flex',
    alignItems: 'center',
    position: 'relative',
    top: 2,
    borderRadius: theme.shape.borderRadius,
    padding: '2px 8px 2px 4px',
    color: 'white',
    '& svg': {
      marginRight: 2,
    },
  },
  selected: {
    backgroundColor: '#efefef',
  },
  devices: {
    tableLayout: 'fixed',
    '& thead .MuiTableCell-stickyHeader': {
      backgroundColor: isDarkTheme(theme) ? '#393939' : '#eeeeee',
      borderBottom: '2px solid rgba(0,0,0,0.12)',
    },

    '& tbody tr:nth-of-type(even)': {
      backgroundColor: isDarkTheme(theme) ? '#393939' : '#fafafa',
    },
  },
  sortableCell: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    '&::hover': {
      color: darken(theme.palette.text.secondary, 0.3),
    },
    '& > svg': {
      width: '18px',
      height: '18px',
      marginLeft: '7px',
    },
  },
  sortableCenter: {
    justifyContent: 'center',
  },
  container: {
    overflow: 'auto',
    [theme.breakpoints.up('md')]: {
      height: 'calc(100vh - 383px)',

      '.withFilters &': {
        height: 'calc(100vh - 420px)',
      },
    },
    [theme.breakpoints.up('lg')]: {
      height: 'calc(100vh - 285px)',
      '.withFilters &': {
        height: 'calc(100vh - 333px)',
      },
    },
    '& tbody td:nth-child(6)': {
      paddingBottom: '8px',
    },
  },
  summary: {
    height: '56px',
    borderTop: '1px',
    borderColor: theme.palette.text.primary,
    backgroundColor: isDarkTheme(theme)
      ? theme.palette.secondary.main
      : '#eeeeee',
  },
  summaryItem: {
    padding: '0 15px',
  },
}));
